import { AfterViewInit, Directive } from "@angular/core";
import { CdkConnectedOverlay } from "@angular/cdk/overlay";


const CUSTOMAN_OVERLAY_VIEWPORT_MARGIN_PX = 100;

@Directive({
  selector: "[cdk-connected-overlay],[connected-overlay],[cdkConnectedOverlay]",
})
export class CdkConnectedOverlayCustomanViewportMarginDirective
  implements AfterViewInit
{
  constructor(private connectedOverlay: CdkConnectedOverlay) {}

  ngAfterViewInit(): void {
    this.connectedOverlay.viewportMargin = Math.max(
      this.connectedOverlay.viewportMargin,
      CUSTOMAN_OVERLAY_VIEWPORT_MARGIN_PX
    );
    if (!this.connectedOverlay.push) {
      this.connectedOverlay.push = true;
    }
  }
}
